export default {"src":"/_next/static/media/KeepaLogoWhite.e11c0d8e.svg","height":113,"width":280};